
import { sortData } from "oolib";
import { queryClient } from "../../index";
import {__GetAllContentTypeConfig} from '../../utils/getters/gettersV2'
import { __GetAccessibleContentTypes, __GetAccessibleContentTypesForTheUser } from "../../utils/accessControl";
import { extractAllBlocksFromTpl } from "@okf/ootils";
import { SERVICE_USER_PROFILE_TYPES } from "../../CONSTANTS";

export const additionalOptionsFns = {
  getTagTypes: () => {
    
    let userTags = queryClient
      .getQueryData("allTpls")
      .filter(tpl => tpl.category === 'userProfiles' && !SERVICE_USER_PROFILE_TYPES.includes(tpl.kp_content_type))
      .map((tpl) => ({
        display: "💁🏽‍♂️ " + (tpl.general?.content?.title || tpl.kp_content_type),
        value: tpl.kp_content_type,
      }));
    let contentTags = __GetAllContentTypeConfig().map((d) => ({
      display: d.general?.content?.title,
      value: d.kp_content_type,
    }));
    return [...userTags, ...contentTags];
  },
  
  getContentTypes: ({injectOptionBefore}) => {
    
    let toReturn = __GetAllContentTypeConfig().map((d) => ({
      display: d.general?.content?.title || d.id,
      value: d.kp_content_type,
    }));
    
    if(injectOptionBefore){
      toReturn = [
        injectOptionBefore,
        ...toReturn
      ]
    }
    return toReturn;
  },
  getValuePathsFromTpls: (args) => { //fully unused right now... but leaving it... in case its handy in the future...
    const tpl = queryClient.getQueryData(['tpl', args?.contentType]);
    const allBlocks = tpl ? extractAllBlocksFromTpl({tpl}) : [];
    if(!args?.blockFilter) {
      const toReturn = allBlocks.map(bl => {
        //we have this map because these components with fixed valuepaths, dont have the possibility of a 'label' of any kind
        const fixedBlockValuePathsMap = {
          'main.title': 'Title', 
          'main.subtitle': 'Subtitle', 
          'main.coverImage': 'Cover Image', 
          'main.coverVideo': 'Cover Video'
        };
        if(Object.keys(fixedBlockValuePathsMap).includes(bl.valuePath)){
          return ({
            display: fixedBlockValuePathsMap[bl.valuePath],
            value: bl.valuePath
          })
        }
        return ({display: bl.props.shortLabel || bl.props.label || bl.valuePath, value: bl.valuePath})
      });
      return toReturn;
    }
  },
  getContentTypeByAction: ({action, excludeSegments}) => {
    const { data: userData } = queryClient.getQueryState("userData");
    let contentTypes = __GetAccessibleContentTypesForTheUser({
      user: userData.user,
      ACTION: action,
    });
    if (excludeSegments) {
      contentTypes = contentTypes.filter(d => !excludeSegments.includes(d.general?.segment));
    }
    return contentTypes.map((d) => ({
      display: d.general?.content?.title || d.id,
      value: d.kp_content_type,
    }));
  },
  getProfileTypes: () => {
    return queryClient
      .getQueryData("allTpls")
      .filter(tpl => tpl.category === 'userProfiles' && !SERVICE_USER_PROFILE_TYPES.includes(tpl.kp_content_type))
      .map((d) => ({
        display: d.general?.content?.title || d.kp_content_type,
        value: d.kp_content_type,
      }));
  },
  getContentStatus: () => [
    { display: "Published", value: "published" },
    { display: "Draft", value: "draft" },
    { display: "Awaiting Review", value: "awaitingModeration" },
    { display: "Under Review", value: "underModeration" },
    { display: "Sent Back", value: "sentBack" },
    { display: "Under Edit", value: "editPublished" },
  ],
  
};




